import { get } from 'lodash';
import cashierApis from 'modules/POS/services/apis';
import { IApiCashierPaymentBody } from 'modules/POS/services/types/payment';
import { useState } from 'react';
import { IResponseData } from 'services/response';
import toast from 'utils/toast';
import { PAYMENT_TYPE } from '../../cashier.constants';
import { cashierCtrl } from '../../cashier.controller';
import CashierActionButton from '../../components/CashierActionButton';
import ModalChooseType from './ModalChooseType';
import ModalEBTFoodPayment, { IModalEBTFoodPaymentMethod, useModalEBTFoodPaymentRef } from './ModalEBTFoodPayment';

const CashierEBTPayment = () => {
  const ebtFoodPaymentRef = useModalEBTFoodPaymentRef();
  const [billId, setBillId] = useState('');

  // const onEBT = async () => {
  //   setPageLoading(true);
  //   try {
  //     const billId = await cashierCtrl.saveTicketForPayment();
  //     if (billId) setBillId(billId);
  //   } catch (error) { }
  //   finally {
  //     setPageLoading(false);
  //   }
  // };

  const onEBT_FOOD = async () => {
    cashierCtrl.saveTicketPaymentWithCallBack((billId) => {
      if (billId) ebtFoodPaymentRef.current?.open(billId);
    });
  };

  const onPaymentWith = async (type: string) => {
    if (!billId) return;
    if (type === PAYMENT_TYPE.EBT_FOOD) {
      return ebtFoodPaymentRef.current?.open(billId);
    }
  };

  const onPayment: IModalEBTFoodPaymentMethod = async (billId, paymentItem) => {
    const body: IApiCashierPaymentBody = {
      billId, payments: [paymentItem],
    };
    try {
      const res: IResponseData<any> = await cashierApis.paymentTicket(body);
      if (res.data.data) {
        return true;
      }
      throw res.data.data;
    } catch (error) {
      const msg = get(error, ['response', 'data', 'message'], 'Fail');
      toast.error(msg);
      return false;
    }
  };

  return (
    <>
      {/* <CashierActionButton
        type='EBT'
        onClick={onEBT}
      /> */}
      <CashierActionButton
        type='EBT_FOOD'
        onClick={onEBT_FOOD}
      />
      <ModalChooseType open={!!billId} onClose={() => setBillId('')}
        onPaymentWith={onPaymentWith}
      />
      <ModalEBTFoodPayment
        ref={ebtFoodPaymentRef}
        onPayment={onPayment}
      />
    </>
  );
};

export default CashierEBTPayment;
